function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import _regeneratorRuntime from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import yoda from '@ks/yoda-js-sdk';
import * as queryString from 'querystring';
import { logger } from './logger';
import { isURL } from './device';
var isInBrowser = typeof window !== 'undefined';
var isProduction = process.env.NODE_ENV === 'production';
export var isInApp = yoda.isInYoda;
var bizId = new URL(window.location.href).searchParams.get('bizId') || 'creative';
export var loadUrl = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var _yoda$webview;
    var params,
      encode,
      isAbsolute,
      devInBrowser,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            params = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            encode = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
            isAbsolute = /^http/.test(url);
            url = addParam(url, params);
            // if(encode){
            //     url = encodeURIComponent(url)
            // }
            console.log('url' + url);
            // 本地开发浏览器环境标志位
            devInBrowser = isInBrowser && !isProduction;
            if (!(/^ikwai/.test(url) || devInBrowser)) {
              _context.next = 10;
              break;
            }
            if (url.indexOf('ikwai://post') !== -1) {
              logger.kwailog.plugins.radar.event({
                name: 'creative-biz',
                event_type: 'to-post'
              });
            }
            window.location.href = url;
            return _context.abrupt("return");
          case 10:
            _context.next = 12;
            return yoda.ready();
          case 12:
            (_yoda$webview = yoda.webview) === null || _yoda$webview === void 0 ? void 0 : _yoda$webview.open({
              url: isAbsolute ? url : location.origin + url
            });
          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function loadUrl(_x) {
    return _ref.apply(this, arguments);
  };
}();
export function addParam(url, params) {
  var sp = url.indexOf('?') === -1 ? '?' : '&';
  var arr = [];
  for (var key in params) {
    // eslint-disable-next-line no-prototype-builtins
    if (params.hasOwnProperty(key)) {
      var value = params[key] === undefined ? '' : params[key];
      encodeURIComponent(key);
      arr.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value)));
    }
  }
  if (arr.length) {
    url += sp + arr.join('&');
  }
  return url;
}
export function openWebview(_x2) {
  return _openWebview.apply(this, arguments);
}
function _openWebview() {
  _openWebview = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url) {
    var query,
      options,
      queryArr,
      queryStr,
      joiner,
      defaultOptions,
      launchOptions,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            query = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            options = _args2.length > 2 ? _args2[2] : undefined;
            queryArr = Object.entries(query).map(function (_ref2) {
              var _ref3 = _slicedToArray(_ref2, 2),
                key = _ref3[0],
                value = _ref3[1];
              return "".concat(key, "=").concat(value);
            });
            queryArr.push('webview=yoda');
            queryStr = queryArr.join('&');
            joiner = url.indexOf('?') !== -1 ? '&' : '?';
            url += joiner + queryStr;
            defaultOptions = {
              topBarBgColor: '#f7f7fa',
              webviewBgColor: '#d2d2d4',
              titleColor: '#222222',
              topBarPosition: 'default',
              statusBarColorType: 'dark'
            };
            launchOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
            _context2.next = 11;
            return yoda.ready();
          case 11:
            yoda.webview.open({
              url: url,
              launchOptions: launchOptions
            });
          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _openWebview.apply(this, arguments);
}
export function openFeedback() {
  loadUrl('https://app.kwai.com/feedback?hyId=feedback&channel=8');
}
export function parseQuery(link) {
  link = link || window.location.search;
  var query = {};
  var search = link.replace(/^\?/g, '');
  if (!search) {
    return {};
  }
  var a = search.split('&');
  var iequ;
  var value = null;
  for (var i = 0, len = a.length; i < len; i++) {
    // 必须用indexOf，不用使用split('=')
    iequ = a[i].indexOf('=');
    if (iequ < 0) {
      iequ = a[i].length;
      value = true;
    } else {
      value = decodeURIComponent(a[i].slice(iequ + 1));
    }
    query[decodeURIComponent(a[i].slice(0, iequ))] = value;
  }
  return query;
}
/**
 *
 * @param path           打开的链接 /creator/center${}
 * @param query         需要拼接在url上的参数
 * @param launchOptions webview 相关的配置
 */
export function openCreatorWebview(_x3) {
  return _openCreatorWebview.apply(this, arguments);
}
/**
 *
 * @param path           打开的链接
 * @param query         需要拼接在url上的参数
 * @param launchOptions webview 相关的配置
 */
function _openCreatorWebview() {
  _openCreatorWebview = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(path) {
    var query,
      launchOptions,
      _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            query = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
            launchOptions = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
            return _context3.abrupt("return", openWebviewBase('/creator/center', path, _objectSpread(_objectSpread({}, query), {}, {
              bizId: bizId
            }), launchOptions));
          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _openCreatorWebview.apply(this, arguments);
}
export function openCreativeWebview(_x4) {
  return _openCreativeWebview.apply(this, arguments);
}
/**
 * 隐藏导航栏的
 * @param path           打开的链接
 * @param query         需要拼接在url上的参数
 * @param launchOptions webview 相关的配置
 */
function _openCreativeWebview() {
  _openCreativeWebview = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(path) {
    var query,
      launchOptions,
      _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            query = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
            launchOptions = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
            return _context4.abrupt("return", openWebviewBase('', path, _objectSpread(_objectSpread({}, query), {}, {
              bizId: bizId
            }), launchOptions));
          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _openCreativeWebview.apply(this, arguments);
}
export function openHideBarWebview(_x5) {
  return _openHideBarWebview.apply(this, arguments);
}
/**
 *
 * @param path           打开的链接 /creator/center${}
 * @param query         需要拼接在url上的参数
 * @param launchOptions webview 相关的配置
 */
function _openHideBarWebview() {
  _openHideBarWebview = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(path) {
    var query,
      launchOptions,
      _args5 = arguments;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            query = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
            launchOptions = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
            return _context5.abrupt("return", openWebviewBase('', path, _objectSpread(_objectSpread({}, query), {}, {
              bizId: 'hideBar'
            }), launchOptions));
          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _openHideBarWebview.apply(this, arguments);
}
export function openWebviewBase() {
  return _openWebviewBase.apply(this, arguments);
}
// 支持端外
function _openWebviewBase() {
  _openWebviewBase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var prefix,
      path,
      query,
      launchOptions,
      finalLaunchOptions,
      url,
      _args6 = arguments;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            prefix = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : '';
            path = _args6.length > 1 ? _args6[1] : undefined;
            query = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
            launchOptions = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : {};
            finalLaunchOptions = _objectSpread({}, launchOptions);
            url = "".concat(location.origin).concat(prefix).concat(path, "?").concat(queryString.stringify(_objectSpread({
              webview: 'yoda',
              source: 'CREATOR_CENTER'
            }, query))); // 现在改为端外也能打开了
            if (!isInApp) {
              _context6.next = 13;
              break;
            }
            _context6.next = 9;
            return yoda.ready();
          case 9:
            _context6.next = 11;
            return yoda.webview.open({
              url: url,
              launchOptions: finalLaunchOptions
            });
          case 11:
            _context6.next = 14;
            break;
          case 13:
            // window.open(url);
            window.location.href = url;
          case 14:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _openWebviewBase.apply(this, arguments);
}
export function openCreatorPage(ctx, path) {
  var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var launchOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  if (yoda.isInYoda) {
    openCreatorWebview(path, query, launchOptions);
  } else {
    var url = "".concat(location.origin, "/creator/center").concat(path, "?").concat(queryString.stringify(_objectSpread({
      webview: 'yoda',
      bizId: bizId,
      source: 'CREATOR_CENTER'
    }, query)));
    location.href = url;
  }
}
// 统一处理
export function loadCreatorUrl(_x6, _x7) {
  return _loadCreatorUrl.apply(this, arguments);
}
function _loadCreatorUrl() {
  _loadCreatorUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(url, params) {
    var myUrl;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (isURL(url)) {
              loadUrl(url, params);
            } else {
              myUrl = url.startsWith('/') ? url : "/".concat(url);
              if (myUrl.startsWith('/creator/')) {
                openCreativeWebview(myUrl, params);
              } else {
                openCreatorWebview(myUrl, params);
              }
            }
          case 1:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _loadCreatorUrl.apply(this, arguments);
}
export function backOrClose() {
  return _backOrClose.apply(this, arguments);
}
function _backOrClose() {
  _backOrClose = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (!isInApp) {
              _context8.next = 6;
              break;
            }
            _context8.next = 3;
            return yoda.ready();
          case 3:
            yoda.webview.backOrClose();
            _context8.next = 7;
            break;
          case 6:
            if (window.history.length <= 1) {
              window.close();
            } else {
              window.history.go(-1);
            }
          case 7:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _backOrClose.apply(this, arguments);
}
export function webviewClose() {
  return _webviewClose.apply(this, arguments);
}
function _webviewClose() {
  _webviewClose = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (isInApp) {
              yoda.webview.close();
            } else {
              window.close();
              // 一般来说不会到这一步
              window.history.go(-1);
            }
          case 1:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _webviewClose.apply(this, arguments);
}
export function useBridge(_x8, _x9) {
  return _useBridge.apply(this, arguments);
}
function _useBridge() {
  _useBridge = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(namespace, name) {
    var params,
      canuseRes,
      ret,
      _args10 = arguments;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            params = _args10.length > 2 && _args10[2] !== undefined ? _args10[2] : {};
            _context10.next = 3;
            return yoda.ready();
          case 3:
            _context10.next = 5;
            return yoda.tool.canIUse({
              namespace: namespace,
              name: name
            });
          case 5:
            canuseRes = _context10.sent;
            if (!(yoda[namespace] && yoda[namespace][name] && canuseRes.canUse)) {
              _context10.next = 11;
              break;
            }
            _context10.next = 9;
            return yoda[namespace][name](params);
          case 9:
            ret = _context10.sent;
            return _context10.abrupt("return", ret);
          case 11:
            return _context10.abrupt("return", {
              result: -404
            });
          case 12:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _useBridge.apply(this, arguments);
}